import Constants from "./Constants";
import { groupBy , sortAllSortBoxItemsByExistingSortboxItems} from "./UtilMethods";
import { AFrameCheckStation } from "../store/types/AFrameTypes";
import { RX_BAG_SKU } from "../../utils/Constants";

const { ActionStates, AFrameStationID, SortBoxDivertReason } = Constants;

export default class AFrameReviewBox {
  reviewBoxModel = void 0;
  data = {};
  containsUnpicked = false;

  constructor(reviewBoxModel) {
    this.reviewBoxModel = reviewBoxModel;
  }

  load = (type) => {
    const {
      sortBoxModel,
      notFound,
      channelItems,
      dynamicChannelItems,
      orderWarnings,
      orderShippingMethod,
      latestShipping,
      allSortBoxItems,
      rxFloorVisited,
      orderStatus,
    } = this.reviewBoxModel;
    const { iPackBoxID, estimatedWeight, cancellationReason } = this.reviewBoxModel.sortBoxAFrame;

    const filteredChannels =
      type === AFrameCheckStation.chk01
        ? channelItems
        : channelItems.filter((c) => c.channel > 30000 || c.channel < 10000);

    const skuChannels = groupBy(filteredChannels, "skuID");
    const skuChannelsDynamic = groupBy(dynamicChannelItems, "skuID");

    //Header diverts first
    let headerWarnings = (orderWarnings.warnings || []).filter((w) => w.header);
    let lineWarnings = (orderWarnings.warnings || []).filter((w) => !w.header);
    lineWarnings = lineWarnings.sort((w1, w2) =>
      w1.channel > w2.channel ? 1 : w2.channel > w1.channel ? -1 : 0
    );

    const sortedWarnings = [...headerWarnings, ...lineWarnings];
    let allSortBoxItemsSorted = sortAllSortBoxItemsByExistingSortboxItems(allSortBoxItems, sortBoxModel.sortBoxItems);
    this.data = {
      notFound: notFound,
      channelItems: skuChannels,
      dynamicChannelItems: skuChannelsDynamic,
      iPackBoxID: iPackBoxID,
      estimatedWeight: estimatedWeight,
      warnings: sortedWarnings,
      hasWarnings: orderWarnings.hasWarnings,
      orderNumber: sortBoxModel.orderNumber,
      boxItems: sortBoxModel.sortBoxItems,
      nextAction: ActionStates.BOX_LOADED,
      boxID: sortBoxModel.sortBoxID,
      sortID: sortBoxModel.sortID,
      shippingMethod: orderShippingMethod,
      latestShipping: latestShipping,
      sortBoxModel: sortBoxModel,
      orderChecked: false,
      allSortBoxItems: allSortBoxItemsSorted,
      rxFloorVisited: rxFloorVisited,
      orderStatus: orderStatus,
      cancellationReason: cancellationReason,
    };

    let shortPick = false;
    if (orderWarnings.hasWarnings) {
      shortPick = this.data.warnings.some(
        (w) => w.divertReason === SortBoxDivertReason.UNFILLED_QUANTITY
      );
    }

    //can we have shortpick without a divert? maybe
    const containsUnpicked = this.data.boxItems.some(
      (item) => item.pickedQuantity < item.reservedQuantity && (item.skuID < RX_BAG_SKU || !rxFloorVisited )
    );

    this.containsUnpicked = containsUnpicked;

  };

  save = () => { };

  updateSortBox = () => { };
}
